import React, { useEffect, useCallback, useState, useRef } from 'react';
import { useLocation, history, useDispatch } from 'umi';
import qs from 'qs';
import dayjs from 'dayjs';
import { Box } from '@material-ui/core';
import ResultList from './components/result_list/ResultList';
import SearchGroup from './components/search_group/SearchGroup';

export default () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { query, pathname } = location;
  const [isSearch, setIsSearch] = useState(false);
  const searchRef = useRef();
  // 结构到所有查询条件，包括分页条件
  const {
    status,
    name,
    beginDateTime,
    endDateTime,
    refreshTime,
    pageNum = '1',
    pageSize = '10',
  } = query;

  // 查询事件处理
  const handleSearch = (newParam) => {
    setIsSearch(true);
    const time = dayjs().format('YYYY-MM-DD HH:mm:ss');
    history.replace(
      `${pathname}?${qs.stringify({
        ...newParam,
        refreshTime: time,
        pageSize,
        pageNum: 1,
      })}`,
    );
  };

  // 翻页事件处理
  const handlePageChange = (p) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        pageNum: p.pageNum,
        pageSize: p.pageSize,
      })}`,
    );
  };

  // 重置事件处理
  const handleRestClick = (rs) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...rs,
        pageSize: 10,
        pageNum: 1,
      })}`,
    );
  };
  //活动列表
  const fetchActivityList = useCallback(() => {
    const values = {
      name,
      status,
      beginDateTime,
      endDateTime,
      refreshTime,
      searchCount: true,
      pageNum,
      pageSize,
    };
    if (isSearch) {
      window.NE_DAWN.trigger(searchRef.current, {
        event: '_ec', // 事件名
        params: { ...values }, // 事件公参
      });
    }
    setIsSearch(false);
    dispatch({
      type: 'activityCouponList/getActivityList',
      payload: {
        values,
      },
    });
  }, [
    beginDateTime,
    dispatch,
    endDateTime,
    name,
    pageNum,
    pageSize,
    refreshTime,
    status,
  ]);

  useEffect(() => {
    fetchActivityList();
  }, [fetchActivityList]);

  return (
    <Box
      data-log={JSON.stringify({
        oid: 'page_marketing_activity_voucher_list',
        isPage: true,
        params: {
          initUrl: window.location.origin + window.location.pathname,
        },
        events: ['_pv', '_pd'],
      })}
    >
      <SearchGroup
        searchRef={searchRef}
        query={query}
        handleSearch={(searchParam) => handleSearch(searchParam)}
        restClick={handleRestClick}
      />
      <ResultList
        pageData={{ pageNum, pageSize }}
        handlePageChange={handlePageChange}
      />
    </Box>
  );
};
